// Dependancies
import { Modal } from 'bootstrap';
import RequestHelper from '../helpers/request-helper';

const Clipboard = require('clipboard');

// Templates
const modalInviteMain = require('../twigs/invite/invite-main.twig');
const modalInviteEmail = require('../twigs/invite/invite-email.twig');
const modalInviteLink = require('../twigs/invite/invite-link.twig');

const requestHelper = new RequestHelper();

// Different Types of Methods
// 1. Actions: Methods that fetch data and populate state
// 2. Handlers: Methods that handle events (prefixed with 'handle')
// 3. Renderers: Methods that render views (prefixed with 'render')
//    a. Render is purely working off of the state.
//    b. Render should decide which template to render AND pass a view model (aka context) to the template.

export default class Invite {
    /**
     * Initiate the Invite modal flow
     *
     * Define mode: "RAF\sweeps" Sweeps will modify the copy and hide the email link.
     * @param options object
     */
    constructor() {
        this.modalContainer = document.getElementById('modal-container');
        this.referralModal = new Modal(this.modalContainer);

        if (FreshStep.LOGGED_IN) {
            this.state = {
                page: '',
                context: {
                    inviteUrl: FreshStep.inviteUrl,
                },
                renderCallback: null,
            };

            // Assign options to object
            this.options = {};
            this.options.preRender = function (state) {};
        }

        // Init
        if (window.location.hash) {
            this.checkHashInvite();
        }

        window.Parsley.addValidator('notequalto', {
            requirementType: 'string',
            validateString(value, element) {
                return value !== $(element).val();
            },
        });

        window.Parsley.addValidator('notequaltoo', {
            requirementType: 'string',
            validateString(value, element) {
                return value !== $(element).val();
            },
        });

        // Click Handlers
        FreshStep.doc.on('click', 'a.js-invite-modal, a[href*="#invite"]', (event) => {
            event.preventDefault();

            window.location.hash = '#invite';
            this.checkHashInvite();
        });
    }

    addOptions(options) {
        // Process options
        if (options.inviteURL) {
            this.state.context.inviteUrl = options.inviteURL;
        }

        if (options.preRender) {
            this.options.preRender = options.preRender;
        }
    }

    /**
     * Hashtag
     * Check to see that the #invite hashtag exists and render the invite modal
     */
    checkHashInvite() {
        if (Electro.DEBUG) {
            console.log('Invite.checkHashInvite()');
        }

        switch (window.location.hash) {
            case '#invite':
                if (FreshStep.LOGGED_IN) {
                    this.renderInviteModal();
                } else {
                    window.location.href = '/user/login/?redirect_to=/dashboard/#invite';
                }
                break;
            default:
                break;
        }
    }

    /**
     * Send emails to the backend
     */
    handleSubmitEmail(list) {
        if (Electro.DEBUG) {
            console.log('Invite.handleSubmitEmail()');
        }

        const $invErr = $('#invite-error');
        $invErr.fadeOut('fast', () => {
            $invErr.html('<p>Inviting...</p>').fadeIn('slow');
        });

        requestHelper
            .makeAuthenticatedRequest('/wp-json/electro/v1/invite/send', 'POST', { email: list })
            .then((response) => {
                if (response.status) {
                    console.info('Email invite error');
                }

                $invErr.fadeOut('slow', () => {
                    $invErr.html('<p>Invites were sent!</p>').fadeIn('slow');
                });
                this.state.page = 'completed';
                this.renderMainPage();
            });
    }

    /**
     * Handler for form submits
     */
    handleSubmit(event) {
        if (Electro.DEBUG) {
            console.log('Invite.handleSubmit()');
        }

        event.preventDefault();

        if ($('#form-invite-email').length) {
            if (!$('#form-invite-email').parsley().validate()) {
                console.log('invalid');
                return;
            }
        }

        const $invErr = $('#invite-error');

        // Compile email addresses
        const list = [];
        $('#form-invite-email input.email-address').each(function () {
            const value = $(this).val();

            if (value && list.indexOf(value) === -1) {
                list.push($(this).val());
            }
        });

        console.info('list: ', list);

        $invErr.fadeOut('fast', () => {
            $invErr.html('');

            requestHelper
                .makeAuthenticatedRequest('/wp-json/electro/v1/invite/checkEmails', 'POST', { email: list })
                .then((response) => {
                    console.info('response: ', response);

                    const { data } = response;

                    if (data.duplicate.length || data.invalid.length) {
                        let errorText = "<p>We can't complete your invitation.</p>";
                        if (data.duplicate.length) {
                            errorText +=
                                `<p>Some emails have already been invited:</p>` +
                                `<ul><li>${data.duplicate.join('</li><li>')}</ul>`;
                        }
                        if (data.invalid.length) {
                            errorText +=
                                `<p>Some emails seem to be invalid:</p>` +
                                `<ul><li>${data.invalid.join('</li><li>')}</ul>`;
                        }
                        errorText += '<p>Please fix these errors and re-submit.</p>';
                        $invErr.html(errorText).fadeIn('slow');
                    } else {
                        this.handleSubmitEmail(list);
                    }
                });
        });
    }

    static handleCopyLink() {

        $('#invite-link .status').removeClass('success, error').hide();
        const clipboard = new Clipboard('.js-copy-link');

        clipboard.on('success', (e) => {
            $('#invite-link .status').addClass('success').text('COPIED TO YOUR CLIPBOARD').fadeIn('200');
            e.clearSelection();
        });

        clipboard.on('error', (e) => {
            console.error('Action:', e.action);
            console.error('Trigger:', e.trigger);
            $('#invite-link .status').addClass('error').text(FreshStep.errorMessageGlobal).fadeIn('200');
        });
    }

    handleSelectPage() {
        let callback;

        switch (this.state.page) {
            case 'facebook':
                this.state.template = modalInviteMain;
                Object.assign(this.state.context, {
                    type: 'facebook',
                });
                break;
            case 'email':
                this.state.template = modalInviteEmail;
                Object.assign(this.state.context, {
                    type: 'email',
                });
                if (!this.state.maxAwarded) {
                    Object.assign(this.state.context, {
                        headerCopy: 'Invite a friend or three',
                        bodyCopy:
                            'Email your fellow cat lovers to join Paw Points. You earn 25 bonus points for every friend that joins (up to 250 points)',
                    });
                }

                callback = () => {
                    $('#form-invite-email').parsley();
                    $('#form-invite-email').on('submit', (event) => {
                        this.handleSubmit(event);
                    });
                };

                this.renderPage(callback);
                break;
            case 'link':
                this.state.template = modalInviteLink;
                Object.assign(this.state.context, {
                    type: 'link',
                });
                if (!this.state.maxAwarded) {
                    Object.assign(this.state.context, {
                        headerCopy: 'Your unique share link',
                        bodyCopy:
                            'Friends link up friends with Paw Points. Remember you’ll get 25 Paw Points<sup>&reg;</sup> for every person that joins (up to 250 points).',
                    });
                }

                callback = () => {
                    Invite.handleCopyLink();
                };

                this.renderPage(callback);
                break;
            default:
                break;
        }
    }

    /**
     * MODAL LISTENERS
     */
    initModalListeners() {
        if (Electro.DEBUG) {
            console.log('Invite.initModalListeners()');
        }

        // Back Button
        $('.modal').off().on('click.inviteModal', '.js-back-btn', (event) => {
            event.preventDefault();
            this.state.page = '';
            Object.assign(this.state.context, {
                type: '',
            });
            this.renderMainPage('back');
        });

        // Social Media Buttons
        $('.js-invite-option').off().on('click.invitePage', (event) => {
            this.state.page = $(event.currentTarget).attr('data-page');
            this.handleSelectPage();
        });
    }

    /**
     * RENDERERS
     */
    renderInviteModal() {
        if (Electro.DEBUG) {
            console.log('Invite.renderInviteModal()');
        }
      
        this.referralModal.show();

        this.state.page = '';
        Object.assign(this.state.context, {
            type: '',
        });

        this.renderMainPage();
    }

    renderMainPage(direction) {
        if (Electro.DEBUG) {
            console.log('Invite.renderMainPage()');
        }

        this.state.template = modalInviteMain;

        if (this.state.page === 'completed') {
            Object.assign(this.state.context, {
                headerCopy: 'THANKS FOR SHARING',
                bodyCopy:
                    'Friends tell feline-loving friends about Paw Points<sup>&reg;</sup>. And that’s just what you’ve done. Remember, you’ll get 25 points for every person that joins (up to 250 points). Want to share more? Go for it.',
            });
        } else {
            Object.assign(this.state.context, {
                headerCopy: 'SHARE THE LOVE',
                bodyCopy:
                    'Invite fellow feline-lovers and get 25 Paw Points<sup>&reg;</sup> for each friend that signs up (up to 250 points).',
            });
        }

        if (typeof this.state.renderCallback === 'function') {
            Object.assign(this.state.context, this.state.renderCallback(this.state.context));
        }

        this.renderPage();
    }

    renderPage(callback = null, direction = null) {
        if (Electro.DEBUG) {
            console.log('Invite.renderPage()');
        }

        // Hook for processing context. Passed by referance
        this.options.preRender(this.state);
        
        $(this.modalContainer).find('.modal-body').html(
            this.state.template(this.state.context)
        );

        if ( callback ) {
            callback();
        }
        this.initModalListeners();
    }
}
